export default __webpack_public_path__ + "static/media/fridge2-beforeA-480w.3cf3a7d6.avif";